export default __webpack_public_path__ + "static/media/panel-modal.323aee17.png";